import type { FC, ReactNode } from 'react'

import { CtaLink } from '@/components/generals/cta-link'
import { Mark } from '@/components/generals/mark'
import { SectionLabel } from '@/components/generals/section-label'
import { GeometricField } from '@/components/graphics/geometric-field'

import { CONTACT } from '@/constants/site'

const CORNERS = [
    'left-0 top-0 border-l border-t',
    'right-0 top-0 border-r border-t',
    'bottom-0 left-0 border-b border-l',
    'bottom-0 right-0 border-b border-r'
]

const FinalCta: FC = (): ReactNode => {
    return (
        <section id='start-a-project' aria-labelledby='final-cta-title' data-nav-theme='dark' className='relative overflow-hidden bg-charcoal text-cream'>
            <div className='mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28'>
                <div className='relative grid gap-14 border border-cream/15 p-6 sm:p-10 md:p-14 lg:grid-cols-12 lg:items-center lg:gap-10'>
                    {CORNERS.map((corner) => (
                        <span key={corner} aria-hidden='true' className={`absolute size-4 border-coral ${corner}`} />
                    ))}

                    <div className='lg:col-span-7'>
                        <SectionLabel tone='dark'>Start a project</SectionLabel>
                        <h2 id='final-cta-title' data-reveal className='mt-6 font-heading type-hero'>
                            <span className='md:block'>Ready to <Mark tone='dark'>grow</Mark></span>{' '}
                            <span className='md:block'>your brand?</span>
                        </h2>
                        <p data-reveal className='mt-6 max-w-xl text-[17px] leading-relaxed text-cream/80'>
                            Tell us what you&apos;re building, where you want to go, and what you want to achieve. Let&apos;s create a marketing strategy that moves your business forward.
                        </p>
                        <div data-reveal className='mt-9 flex flex-wrap items-center gap-x-8 gap-y-5'>
                            <CtaLink href='/contact' variant='primary-dark'>
                                Let&apos;s start a project
                            </CtaLink>
                            {CONTACT.email && (
                                <a
                                    href={`mailto:${CONTACT.email}`}
                                    className='font-mono text-[11px] uppercase tracking-[0.14em] text-cream/75 underline-offset-4 transition-colors hover:text-coral hover:underline'
                                >
                                    Or email us
                                </a>
                            )}
                        </div>
                    </div>

                    <div className='relative mx-auto w-full max-w-[380px] lg:col-span-4 lg:col-start-9 lg:max-w-none'>
                        <div data-parallax='6'>
                            <GeometricField className='h-auto w-full text-cream' />
                        </div>
                        <p className='mt-4 flex justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-cream/60'>
                            <span>Fig. 01 / Growth</span>
                            <span>BLITZ</span>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FinalCta
